import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { UtilizationReport } from "@src/components/modules/reports/utilization/UtilizationReport";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/utilization",
  title: () => t`Utilization`,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <UtilizationReport />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/utilization")({
  component: Page,
});
